export default __webpack_public_path__ + "static/media/img_step_appliance03.a9213790.jpg";